<template>
  <!-- Allows user to update previous question answers -->
  <!-- TODO turn summary edit into card component -->
  <div class="summary-edit">
    <div
      v-for="(product, i) in products"
      :key="i"
      class="summary-edit__item"
      :class="{'summary-edit__disable' : isInactive(product.qName, product.count)}"
    >
      <component
        :is="product.iconComponent"
        :inactive="isInactive(product.qName, product.count)"
        class="summary-edit__item__icon"
      />
      <p class="summary-edit__item__name">
        {{ product.name }}
      </p>
      <component
        :is="product.inputComponent"
        v-model="product.count"
        :items="product.selectOptionsItems"
        class="summary-edit__item__input"
      />
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { LOCATIONS_OPTIONS } from '@/constants/question-options'
import sortDescending from '@/helpers/sorting/sortDescending'
import { QID_DEVICES, QID_APP_USERS, QID_LOCATIONS } from '@/constants/question-ids'

export default {
  name: 'SummaryEdit',
  components: {
    DeskPhoneSVG: () => import('@/components/svg/icons/DeskPhoneSVG'),
    CordLessPhoneSVG: () => import('@/components/svg/icons/CordlessPhoneSVG'),
    DesktopMobileAppUsers: () => import('@/components/svg/icons/DesktopMobileAppUsersSVG'),
    LocationsSVG: () => import('@/components/svg/icons/LocationsSVG'),
    ConferencePhoneSVG: () => import('@/components/svg/icons/ConferencePhoneSVG'),
    InputNumericBox: () => import('@/components/ui/InputNumericBox'),
    SelectOptionBox: () => import('@/components/ui/SelectOptionBox')
  },
  data () {
    return {
      products: [
        {
          id: 'desk-phones',
          name: 'Desk phones',
          iconComponent: 'DeskPhoneSVG',
          inputComponent: 'InputNumericBox',
          count: this.getDeviceStoreCount('deskPhones'),
          qName: QID_DEVICES
        },
        {
          id: 'cordless-phones',
          name: 'Cordless phones',
          iconComponent: 'CordLessPhoneSVG',
          inputComponent: 'InputNumericBox',
          count: this.getDeviceStoreCount('cordlessPhones'),
          qName: QID_DEVICES
        },
        {
          id: 'desktop-mobile-app-users',
          name: 'Desktop/Mobile app users',
          iconComponent: 'DesktopMobileAppUsers',
          inputComponent: 'InputNumericBox',
          count: this.getStoreQuestionResult(QID_APP_USERS),
          qName: QID_APP_USERS
        },
        {
          id: 'locations-with-devices',
          name: 'Locations with devices',
          iconComponent: 'LocationsSVG',
          inputComponent: 'SelectOptionBox',
          selectOptionsItems: LOCATIONS_OPTIONS,
          count: this.getStoreQuestionResult(QID_LOCATIONS),
          qName: QID_LOCATIONS
        },
        {
          id: 'conference-phones',
          name: 'Conference phones',
          iconComponent: 'ConferencePhoneSVG',
          inputComponent: 'InputNumericBox',
          count: this.getDeviceStoreCount('conferencePhones'),
          qName: QID_DEVICES
        }
      ]
    }
  },
  watch: {
    'products': {
      handler: function () {
        // watch for user update in prodcuts
        // Find specfic object from products data return count
        const deskPhones = this.findProductCount('desk-phones')
        const conferencePhones = this.findProductCount('conference-phones')
        const cordlessPhones = this.findProductCount('cordless-phones')
        const locationDevices = this.findProductCount('locations-with-devices')
        const desktopMobileAppUsers = this.findProductCount('desktop-mobile-app-users')
        // Update the devices question answer if products are updated by user
        this.SET_ANSWER({
          questionId: 'qid_devices',
          answer: {
            result: {
              deskPhones,
              cordlessPhones,
              conferencePhones
            }
          }
        })
        // Update the locations answer if products are updated by user
        this.SET_ANSWER({
          questionId: 'qid_locations',
          answer: {
            result: locationDevices
          }
        })
        // Update the app devices answer if products are updated by user
        this.SET_ANSWER({
          questionId: 'qid_app_users',
          answer: {
            result: desktopMobileAppUsers
          }
        })
      },
      deep: true
    }
  },
  mounted () {
    const productsCopy = [...this.products]
    // order products so count with 0 are at the bottom
    const productCountDescending = sortDescending(productsCopy, 'count')
    this.products = productCountDescending
    this.$emit('input', { result: 'default making next btn available without answer' })
  },
  methods: {
    ...mapMutations(['SET_ANSWER']),
    getDeviceStoreCount (deviceType) {
      if (!this.$store.state.Questions.answers.qid_devices) return 0
      return Number(this.$store.state.Questions.answers.qid_devices.result[deviceType])
    },
    getStoreQuestionResult (questionName) {
      return this.$store.state.Questions.answers[questionName].result
    },
    findProductCount (idSearched) {
      // Find object with id
      return this.products.find(product => product.id === idSearched).count
    },
    isInactive (qName, count) {
      const arr = this.$store.state.Questions.skippedQuestions
      if (arr.includes(qName) && count === 0) return true
      return false
    }
  }
}
</script>

<style lang="scss">
.summary-edit {
  &__disable {
    .summary-edit {

      &__item {

          &__input {
          .select-dropdown__box {
            color: $bionic-grey-600;
          }
        }

      }
    }

  }
}
</style>

<style lang="scss" scoped>
.summary-edit {
  margin-left: auto;
  margin-right: auto;
  height: 387px;
  width: 288px;
  border-radius: 6px;
  background-color: $white;
  box-shadow: 0 2px 11px 0 rgba(30, 45, 114, 0.1);

   @media (min-width: 421px) and (max-width: 719px) {
    width: 340px;
  }

  @media (min-width: 720px) {
    width: 400px;
  }
  &__disable {

    .summary-edit {

      &__item {

        &__name,
        &__input {
          color: $bionic-grey-600;

        }
          &__input {
          .select-dropdown__box {
            color: $bionic-grey-600;
          }
        }

      }
    }

  }

  &__item {
    display: flex;
    align-items: center;
    height: 65px;
    border-bottom: 1px solid $bionic-grey-600;
    padding: 38px 18px;

  &__input {
    margin-left: auto;
  }

    &:last-child {
      border-bottom: none;
    }

    &__icon {
      margin-right: 16px;

      @media (min-width: $screen-md) {
        margin-right: 26px;
      }
    }

    &__name {
      margin: 0;
      font-size: 14px;
      line-height: 20px;
      color: $black;
      width: 129px;
      text-align: left;
      line-height: 17px;

      @media (min-width: $screen-md) {
        font-size: 16px;
        width: auto;
      }
    }
  }
}
// Remove input number arrows
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>
